import SimpleTablePage from "../common/SimpleTablePage";
import { date2locale } from "../common/common";

const columns = [
  { title: "ID", dataIndex: "id", key: "id", fixed: "left", width: 70 },
  {
    title: "Dipendente",
    dataIndex: ["employee", "fullName"],
    key: "employee",
    ellipsis: true,
    width: 200,
  },
  { title: "Categoria", dataIndex: ["type", "name"], key: "type", ellipsis: true, width: 150 },
  { title: "Data", dataIndex: "date", key: "date", width: 120, render: date2locale },
];

export default function Absences() {
  return <SimpleTablePage resource="absence" columns={columns} />;
}
